//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.1.0.0 (Newtonsoft.Json v13.0.0.0) (http://NJsonSchema.org)
// </auto-generated>
//----------------------







export enum CourseElementType {
    Text = 0,
    MdText = 1,
    Image = 2,
    Video = 3,
    Audio = 4,
    AudioPodcast = 5,
    TtsAudio = 6,
    TtsSpeak = 7,
    MultipleChoice = 8,
    SingleChoice = 9,
    Slider = 10,
    Comment = 11,
    Rating = 12,
    Link = 13,
    Pdf = 14,
    Signature = 15,
    Scorm = 16,
    HeroHeadline = 17,
    SequentialList = 18,
    FlipCardList = 19,
}